import { render, staticRenderFns } from "./createRole.vue?vue&type=template&id=6e355f38"
import script from "./createRole.vue?vue&type=script&lang=js"
export * from "./createRole.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports